import { VoiceServer } from "callable-data-objects";
import { useVoiceRegion } from "Hooks/Endpoints";
import React from "react";
import { Button, Checkbox, Table } from "semantic-ui-react";

const VoiceServerTable = () => {
  const { voiceRegion, selectVoiceServer } = useVoiceRegion();

  return (
    <Table celled padded stackable>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell singleLine>Name</Table.HeaderCell>
          <Table.HeaderCell singleLine>Private IP</Table.HeaderCell>
          <Table.HeaderCell singleLine>Public IP</Table.HeaderCell>
          <Table.HeaderCell singleLine>DNS</Table.HeaderCell>
          <Table.HeaderCell singleLine>Teams Proxy</Table.HeaderCell>
          <Table.HeaderCell singleLine>Teams DNS</Table.HeaderCell>
          <Table.HeaderCell singleLine>Interconnect</Table.HeaderCell>
          <Table.HeaderCell singleLine>Access</Table.HeaderCell>
          <Table.HeaderCell singleLine>Group</Table.HeaderCell>
          <Table.HeaderCell width={1}>Actions</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {voiceRegion.voiceServers.map((server: VoiceServer) => (
          <Table.Row key={`tr-ddi-${server.id}`}>
            <Table.Cell singleLine>{server.name}</Table.Cell>
            <Table.Cell singleLine>{server.privateIP}</Table.Cell>
            <Table.Cell singleLine>{server.publicIP}</Table.Cell>
            <Table.Cell singleLine>{server.dns}</Table.Cell>
            <Table.Cell singleLine>
              <Checkbox toggle checked={server.teamsProxy} />
            </Table.Cell>
            <Table.Cell singleLine>{server.teamsDNS}</Table.Cell>
            <Table.Cell singleLine>
              <Checkbox toggle checked={server.interconnect} />
            </Table.Cell>
            <Table.Cell singleLine>
              <Checkbox toggle checked={server.access} />
            </Table.Cell>
            <Table.Cell singleLine>{server.group}</Table.Cell>
            <Table.Cell textAlign='left'>
              <Button
                primary
                size='tiny'
                onClick={() => selectVoiceServer(server.id)}
              >
                Select
              </Button>
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );
};

export default VoiceServerTable;
